import { Component } from '@angular/core';

@Component({
    selector: 'app-dev',
    templateUrl: './dev.component.html',
    styleUrl: './dev.component.scss',
    standalone: true
})
export class DevComponent {

}
